import { Grid } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { darken } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import combineStyles from 'classnames';
import { useTranslation } from 'react-i18next';
import OldThemedButton from './OldThemedButton';

const useStyles = makeStyles((theme) => ({
  nextButton: {
    borderRadius: 0,
    [theme.breakpoints.down('xs')]: {
      borderRadius: '0px 4px 4px 0px',
    },
  },
  btn: {
    borderLeft: `1px solid ${darken('#0F7B85', 0.1)}`,
    '&:disabled': {
      border: 0,
    },
  },
  btnHover: {
    '&:hover': {
      backgroundColor: '#0B4E54',
      opacity: 0.8,
    },
  },
}));

const SurveyNav = ({ questionIndex, isMissingRequirements, onClickNext, onClickPrev }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const isFirstQuestion = questionIndex === 0;

  const prevLabel = t('survey.navigation.previous');
  const nextLabel = t('survey.navigation.next');

  return (
    <>
      <Grid item>
        <OldThemedButton
          disabled={isFirstQuestion}
          aria-hidden={isFirstQuestion}
          onClick={onClickPrev}
          className={combineStyles(styles.btn, styles.btnHover)}
          variant="outlined"
          aria-label={prevLabel}
          tabIndex={0}
        >
          {t('survey.navigation.previous')}
        </OldThemedButton>
      </Grid>

      <Grid item>
        <OldThemedButton
          disabled={isMissingRequirements}
          aria-hidden={isMissingRequirements}
          onClick={onClickNext}
          className={combineStyles(styles.btn, styles.btnHover)}
          variant="outlined"
          aria-label={nextLabel}
          tabIndex={0}
        >
          {t('survey.navigation.next')}
        </OldThemedButton>
      </Grid>
    </>
  );
};

SurveyNav.propTypes = {
  questionIndex: PropTypes.number,
  isMissingRequirements: PropTypes.bool,
  onClickNext: PropTypes.func,
  onClickPrev: PropTypes.func,
};

export default SurveyNav;
